// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_body__tsfGc {
  background: #000;
  padding: 60px 0;
}

.footer_wrapper__3XTBO {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer_dataLinks__WgxrO {
  display: flex;
  align-items: center;
  grid-gap: 4px;
}

.footer_linksToApplications__py\\+Fa span {
  font-family: Inter;
  font-size: 18px;
  font-weight: 500;
  display: inline-block;
  color: #fff;
  margin-bottom: 12px;
}
.footer_linksToApplications__py\\+Fa .footer_actions__A212h {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  grid-gap: 12px;
}

.footer_links__sRCmB {
  display: flex;
  font-family: Inter;
  align-items: flex-start;
  flex-direction: column;
  grid-gap: 7px;
}
.footer_links__sRCmB p {
  color: #D1D5DB;
  font-size: 12px;
}
.footer_links__sRCmB div {
  display: flex;
  align-items: center;
  gap: 24px;
}
.footer_links__sRCmB a {
  color: #D1D5DB;
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
  margin-top: 4px;
  text-decoration: underline;
}

.footer_copyright__izYg2 {
  color: #D1D5DB;
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  margin-top: 24px;
}

@media (max-width: 430px) {
  .footer_links__sRCmB {
    flex-wrap: wrap;
    align-items: flex-start !important;
  }
  .footer_dataLinks__WgxrO {
    flex-direction: column;
    align-items: flex-start !important;
    grid-gap: 6px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAIE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;AAFJ;;AAMA;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;AAHF;AAIE;EACE,cAAA;EACA,eAAA;AAFJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFJ;AAIE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;AAFJ;;AAOA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAQA;EACE;IACE,eAAA;IACA,kCAAA;EALF;EAOA;IACE,sBAAA;IACA,kCAAA;IACA,wBAAA;EALF;AACF","sourcesContent":[".body {\r\n  background: #000;\r\n  padding: 60px 0;\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.dataLinks {\r\n  display: flex;\r\n  align-items: center;\r\n  grid-gap: 4px;\r\n}\r\n\r\n.linksToApplications {\r\n  \r\n  span {\r\n    font-family: Inter;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    display: inline-block;\r\n    color: #fff;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .actions {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    grid-gap: 12px;\r\n  }\r\n}\r\n\r\n.links {\r\n  display: flex;\r\n  font-family: Inter;\r\n  align-items: flex-start;\r\n  flex-direction: column;\r\n  grid-gap: 7px;\r\n  p {\r\n    color: #D1D5DB;\r\n    font-size: 12px;\r\n  }\r\n  div {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 24px;\r\n  }\r\n  a {\r\n    color: #D1D5DB;\r\n    font-family: Inter;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    margin-top: 4px;\r\n    text-decoration: underline;\r\n  }\r\n\r\n}\r\n\r\n.copyright {\r\n  color: #D1D5DB;\r\n  font-family: Inter;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  margin-top: 24px;\r\n}\r\n\r\n\r\n@media (max-width: 430px) {\r\n  .links {\r\n    flex-wrap: wrap;\r\n    align-items: flex-start !important;\r\n  }\r\n  .dataLinks {\r\n    flex-direction: column;\r\n    align-items: flex-start !important;\r\n    grid-gap: 6px !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `footer_body__tsfGc`,
	"wrapper": `footer_wrapper__3XTBO`,
	"dataLinks": `footer_dataLinks__WgxrO`,
	"linksToApplications": `footer_linksToApplications__py+Fa`,
	"actions": `footer_actions__A212h`,
	"links": `footer_links__sRCmB`,
	"copyright": `footer_copyright__izYg2`
};
export default ___CSS_LOADER_EXPORT___;
